import { FlagTheme } from '../../types';

export const FLAG_DEFAULT_THEME: FlagTheme = {
    height: 36,
    paddingX: 20,
    radius: 5,
    shadow: 'xs',
    variant: {
        default: {
            typographyVariant: 'body.s',
            fontWeight: 'bold',
        },
        hero: {
            typographyVariant: 'hero.s',
            fontWeight: 'default',
        },
    },
    colors: {
        primary: {
            background: 'primary.base',
            text: 'common.white',
        },
        secondary: {
            background: 'secondary.base',
            text: 'common.white',
        },
        tertiary: {
            background: 'accent.base',
            text: 'common.black',
        },
    },
    fixedColors: {
        neutral: {
            background: 'neutral.lightest',
            text: 'common.black',
        },
        black: {
            background: 'common.black',
            text: 'common.white',
        },
        white: {
            background: 'common.white',
            text: 'common.black',
        },
    },
};
